import type { CampaignTypes } from '../types/campaign.types';
import type { ICampaignConfig } from './campaignConfig.types';
import { tournamentsConfig } from './variants/tournaments.config';
import { prizePopConfig } from './variants/prizePop.config';
import { rebateConfig } from './variants/rebate.config';

export const campaignConfigRegistry: Record<CampaignTypes, ICampaignConfig> = {
    tournaments: tournamentsConfig,
    prize_pop: prizePopConfig,
    rebate: rebateConfig,
};

export type * from './campaignConfig.types';
